// Single accessor for REACT_APP_* config: reads window.__ENV__ (written at container start), falls back to the build-time value unless RUNTIME_CONFIG_REQUIRED (production build) says otherwise.
type EnvMap = Record<string, string | undefined>;

const buildTimeEnv: EnvMap = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_GET_STREAM_API_KEY: process.env.REACT_APP_GET_STREAM_API_KEY,
  REACT_APP_MOBILE_APP_URL: process.env.REACT_APP_MOBILE_APP_URL,
};

// Local dev only (see the RUNTIME_CONFIG_REQUIRED branch below): callers no longer hardcode this, so `npm start` without a .env keeps working.
const devDefaults: EnvMap = {
  REACT_APP_API_URL: "http://localhost:3001/api",
};

declare global {
  interface Window {
    __ENV__?: EnvMap;
  }
}

let warnedMissingRuntimeConfig = false;

export function env(name: string): string | undefined {
  if (typeof window === "undefined") {
    return buildTimeEnv[name];
  }

  if (window.__ENV__ !== undefined) {
    const value = window.__ENV__[name];
    return value !== undefined && value !== "" ? value : buildTimeEnv[name];
  }

  if (process.env.RUNTIME_CONFIG_REQUIRED !== "true") {
    return buildTimeEnv[name] || devDefaults[name];
  }

  if (!warnedMissingRuntimeConfig) {
    warnedMissingRuntimeConfig = true;
    console.error("env-config.js not loaded");
  }
  return undefined;
}
